import { render } from "./Section8Info.vue?vue&type=template&id=23acbc78&ts=true"
import script from "./Section8Info.vue?vue&type=script&lang=ts"
export * from "./Section8Info.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__